import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/move-in")({
  beforeLoad: ({ context }) => guardRoute(context.me, "move-in"),
  component: Outlet,
});
